import { useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import { plus_rounded, google_drive } from "../../assets/images/images";
import { Link, useLocation } from "react-router";
import GoogleLoginComponent from "../GoogleLogin/GoogleLoginComponent";
import { useEffect, useRef, useState } from "react";
import "./Sidebar.css";
import { useRepoQuery } from "../FileRepo/hooks/useRepoQuery";
import { useAuth } from "../../features/auth/AuthContext";
import { StorageIcon } from "../FileRepo/Icons";

const Sidebar = ({
  activeTab,
  setActiveTab,
  tabList,
  toggleCourse,
  toggleAddSchool,
  toggleshowAddProfile,
  toggleAddAdmin,
  dropdownOptions,
}) => {
  const { role } = useSelector((state) => state.globalState);
  const location = useLocation();
  const urlLocation = location.pathname.split("/")[
    location.pathname.split("/").length - 1
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState("0px");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const contentRef = useRef(null);
  const { token } = useAuth();

  const { data, isLoading, isFetching } = useRepoQuery({
    token,
    endpoint: "manual-upload/folder-contents/",
    queryKey: "folderContents",
    folderId: 1,
    page: 1,
  });

  let selectedTab;

  if (role === "Student") {
    selectedTab = "";
  } else {
    selectedTab = urlLocation.length
      ? tabList.find((tab) => tab.route === urlLocation)?.key
      : tabList[0].key;
  }

  useEffect(() => {
    if (isOpen) {
      setHeight(`${contentRef?.current?.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isOpen]);

  useEffect(() => {
    const matchedOption = dropdownOptions.find(
      (option) =>
        location.pathname === `/dashboard/${option?.route?.toLowerCase()}`,
    );

    if (matchedOption) {
      setActiveDropdown(matchedOption.key);
      setActiveTab("My Files");
      setIsOpen(true);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="dashboardSidePannel relative">
        {role === "Teacher" && activeTab === tabList[0].key ? (
          <div className="create-course" onClick={() => toggleCourse("hidden")}>
            <ReactSVG src={plus_rounded} />
            <p className="create-course-text">Create Course</p>
          </div>
        ) : null}

        {/* {(role === "Admin" || role === "SuperAdmin") &&
          selectedTab === "Teachers" ? (
          <div className="create-course" onClick={() => toggleshowAddProfile("hidden", "Teacher")}>
            <ReactSVG src={plus_rounded} />
            <p className="create-course-text">Add Teacher</p>
          </div>
        ) : null}

        {(role === "Admin" || role === "SuperAdmin") &&
        selectedTab === "Students" ? (
          <div
            className="create-course"
            onClick={() => toggleshowAddProfile("hidden", "Student")}
          >
            <ReactSVG src={plus_rounded} />
            <p className="create-course-text">Add Student</p>
          </div>
        ) : null} */}

        {role === "SuperAdmin" && selectedTab === "Schools" ? (
          <div
            className="create-course"
            onClick={() => toggleAddSchool("hidden")}
          >
            <ReactSVG src={plus_rounded} />
            <p className="create-course-text">Add School</p>
          </div>
        ) : null}

        {tabList
          .filter((tab) => tab.role === role)
          .map((tab, index) => {
            const isTabActive =
              selectedTab === tab.key ||
              tab?.dropdown?.some((opt) => opt.key === activeDropdown);
            return (
              <>
                <Link
                  to={`/dashboard/${tab.route.toLowerCase()}`}
                  key={index}
                  onClick={() => {
                    if (
                      tab?.key === activeTab &&
                      tab?.dropdown &&
                      isOpen &&
                      !activeDropdown
                    ) {
                      setIsOpen(false);
                    } else if (
                      tab?.key === activeTab &&
                      tab?.dropdown &&
                      isOpen &&
                      activeDropdown
                    ) {
                      setActiveTab(tab.key);
                      setActiveDropdown(null);
                    } else if (tab?.key === activeTab && tab?.dropdown) {
                      setIsOpen(!isOpen);
                    } else {
                      setIsOpen(false);
                      setActiveTab(tab.key);
                      setActiveDropdown(null);
                    }
                  }}
                  className={(isTabActive ? "active" : "") + " dashboardlink"}
                >
                  <ReactSVG
                    src={tab.value}
                    className={isTabActive ? "svg-active" : "svg-inactive"}
                  />
                  <span
                    className={`${
                      isTabActive
                        ? "text-[#0068FF] font-medium"
                        : "text-black font-normal"
                    }  `}
                  >
                    {tab.key}
                  </span>
                  {tab?.dropdown ? (
                    <>
                      <span className={`arrow ${isOpen ? "rotate" : ""}`}>
                        <svg
                          width="10"
                          height="5"
                          viewBox="0 0 10 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 5L0 0H10L5 5Z"
                            fill={isTabActive ? "#0068FF" : "#808080"}
                          />
                        </svg>
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </Link>
                {tab?.dropdown && isOpen ? (
                  <div
                    ref={contentRef}
                    className="collapsible"
                    style={{ maxHeight: height }}
                  >
                    {tab?.dropdown?.map((option, index) => (
                      <button
                        key={option?.key}
                        className="dropdown-btn-sidebar"
                      >
                        <Link
                          to={`/dashboard/${option?.route?.toLowerCase()}`}
                          key={index + option?.key + index}
                          onClick={() => setActiveDropdown(option?.key)}
                          className={
                            activeDropdown === option?.key
                              ? "active-btn-sidebar"
                              : "inactive-btn-sidebar"
                          }
                        >
                          {option?.key}
                        </Link>
                      </button>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
              </>
            );
          })}
        {role === "Admin" ? (
          <div className="create-course" onClick={toggleAddAdmin}>
            <ReactSVG src={plus_rounded} />
            <p className="create-course-text">Add Admin</p>
          </div>
        ) : null}

        {(urlLocation === "files" ||
          urlLocation === "favourites" ||
          urlLocation === "activity" ||
          urlLocation === "bin") &&
          data?.storage && window.innerWidth > 768 && (
            <div className="sidebar-storage px-2 truncate text-[#555555] font-medium text-[0.8rem] flex items-center gap-2 absolute bottom-2 flex-wrap">
              <StorageIcon />
                {data?.storage?.toFixed(2)}% Storage Used{" "}
            </div>
          )}
      </div>
    </>
  );
};

export default Sidebar;
